var __TEMP__ = require('./_arraySample.js');var arraySample = __REQUIRE_DEFAULT__(__TEMP__);
var __TEMP__ = require('./_baseSample.js');var baseSample = __REQUIRE_DEFAULT__(__TEMP__);
var __TEMP__ = require('./isArray.js');var isArray = __REQUIRE_DEFAULT__(__TEMP__);

/**
 * Gets a random element from `collection`.
 *
 * @static
 * @memberOf _
 * @since 2.0.0
 * @category Collection
 * @param {Array|Object} collection The collection to sample.
 * @returns {*} Returns the random element.
 * @example
 *
 * _.sample([1, 2, 3, 4]);
 * // => 2
 */
function sample(collection) {
  var func = isArray(collection) ? arraySample : baseSample;
  return func(collection);
}

if (!exports.__esModule) Object.defineProperty(exports, "__esModule", { value: true });exports.default = sample;
